import React, { Component } from 'react'

export default class is404 extends Component {
  render() {
    return (
      <div>404 page</div>
    )
  }
}